type TranslatorKey =
  | 'administrativeStatus'
  | 'auctionStatus'
  | 'vehicleInventoryStatus'
  | 'vehicleGeneralStatus'
  | 'qaStatus'
  | 'grayCardStatus'

type StatusValue = {
  title: string
  value: string
}

type StatusEnum = {
  name: TranslatorKey
  label: string
  values: Array<StatusValue>
}

type Translator = {
  mode: 'array'
  enums: Array<StatusEnum>
}

// type TranslatorKeys = Exclude<keyof Translator, 'mode'>

const dummyTranslator: Translator = {
  mode: 'array',
  enums: [
    {
      name: 'auctionStatus',
      label: 'openauction.auctionStatus.select.lot',
      values: [
        {
          title: 'Initial',
          value: '0',
        },
        {
          title: 'En préparation',
          value: '1',
        },
        {
          title: 'En vente',
          value: '2',
        },
        {
          title: 'Vendu',
          value: '3',
        },
        {
          title: 'Réglé',
          value: '4',
        },
        {
          title: 'Pas à vendre',
          value: '5',
        },
      ],
    },
    {
      name: 'vehicleInventoryStatus',
      label: 'openauction.lotInventoryStatus.select.lot',
      values: [
        {
          title: 'Initial',
          value: '0',
        },
        {
          title: 'A enlever',
          value: '1',
        },
        {
          title: 'En transfert',
          value: '2',
        },
        {
          title: 'En stock',
          value: '3',
        },
        {
          title: 'Sorti de stock',
          value: '4',
        },
        {
          title: 'Annulé',
          value: '6',
        },
      ],
    },
    {
      name: 'vehicleGeneralStatus',
      label: 'openauction.lotGeneralStatus.select',
      values: [
        {
          title: 'Initial',
          value: '0',
        },
        {
          title: 'En stock',
          value: '1',
        },
        {
          title: 'En vente',
          value: '2',
        },
        {
          title: 'Vendu',
          value: '3',
        },
        {
          title: 'Délivré',
          value: '4',
        },
        {
          title: 'Repris',
          value: '5',
        },
        {
          title: 'Restitué',
          value: '6',
        },
        {
          title: 'Bloqué',
          value: '7',
        },
        {
          title: 'Annulé',
          value: '8',
        },
      ],
    },
    {
      name: 'administrativeStatus',
      label: 'openauction.currentMissionLotDocStatus.select',
      values: [
        {
          title: 'Incomplet',
          value: '0',
        },
        {
          title: 'A corriger',
          value: '1',
        },
        {
          title: 'Complet',
          value: '2',
        },
      ],
    },
    {
      name: 'qaStatus',
      label: 'openauction.currentMissionLotQualiteVPAutoStatus.select',
      values: [
        {
          title: 'Incomplet',
          value: '0',
        },
        {
          title: 'A Traiter',
          value: '1',
        },
        {
          title: 'A corriger',
          value: '2',
        },
        {
          title: 'Complet',
          value: '3',
        },
      ],
    },
    {
      name: 'grayCardStatus',
      label: 'registrationDocument.status.selection',
      values: [
        {
          title: 'A demander',
          value: '0',
        },
        {
          title: 'Demandée',
          value: '1',
        },
        {
          title: 'Reçue',
          value: '2',
        },
        {
          title: 'Reçue et saisie',
          value: '3',
        },
        {
          title: 'Envoyé',
          value: '4',
        },
      ],
    },
  ],
}

export type { Translator, StatusEnum, TranslatorKey }
export { dummyTranslator }
